import { useMutation, useQueryClient } from '@tanstack/react-query';
import { setSupervisorForLoggedInUserInClass } from 'src/api/classAPI';
import ApiError from 'src/api/errorHandling/ApiError';
import { createQrSupervisorInvitation, sendSupervisorInvitation } from 'src/api/invitationAPI';

export function useSendSupervisorInvitation(onSuccess: () => void) {
  return useMutation<void, ApiError, string>({
    mutationFn: sendSupervisorInvitation,
    onSuccess,
  });
}

export function useCreateQrSupervisorInvitation() {
  return useMutation<string, ApiError, void>({
    mutationFn: createQrSupervisorInvitation,
  });
}

export function useSetSupervisorForStudentMutation() {
  const queryClient = useQueryClient();

  return useMutation<void, ApiError, { classId: number; supervisorUserId: number }>({
    mutationFn: ({ classId, supervisorUserId }) => setSupervisorForLoggedInUserInClass(classId, supervisorUserId),
    onSuccess: () => {
      queryClient.invalidateQueries();
    },
  });
}
